import { cva } from "class-variance-authority"
import Actions from "./DialogActions.svelte"
import Close from "./DialogClose.svelte"
import Content from "./DialogContent.svelte"
import Description from "./DialogDescription.svelte"
import Overlay from "./DialogOverlay.svelte"
import Portal from "./DialogPortal.svelte"
import Root from "./DialogRoot.svelte"
import Title from "./DialogTitle.svelte"
import Trigger from "./DialogTrigger.svelte"

export type { DialogRootProps } from "./DialogRoot.svelte"

export const Dialog = {
  Content,
  Portal,
  Root,
  Trigger,
  Description,
  Close,
  Title,
  Overlay,
  Actions,
}

export const titleVariants = cva(
  "title font-xlarge-650 flex flex-row items-center justify-between",
  {
    variants: {
      variant: {
        confirmation: "text-general-primary-text",
        modal: `text-general-primary-text gap-2 rounded-t-md`,
        warning: "",
      },
    },
    defaultVariants: {
      variant: "confirmation",
    },
  }
)

export const actionsVariants = cva("flex w-full gap-2", {
  variants: {
    variant: {
      horizontal: "mobile:flex-col-reverse max-sm:flex-col-reverse",
      vertical: "flex-col items-center",
    },
  },
  defaultVariants: {
    variant: "horizontal",
  },
})

export const contentVariants = cva(
  "absolute-center-y shadow-bottom-150 data-[state=open]:animate-show fixed inset-x-0 z-40 mx-auto max-h-[90vh] w-[90vw] max-w-xl overflow-x-hidden overflow-y-auto rounded-lg",
  {
    variants: {
      variant: {
        confirmation: "border-general-neutral-01 bg-general-surface-01 border",
        modal:
          "border-general-neutral-01 bg-general-surface-01 border focus-visible:ring-2 focus-visible:outline-hidden",
        warning: "border-alert-pending bg-alert-order-working border",
      },
      // V2 will shift away from padding between elements and prefer margin
      spacing: {
        standard: "space-y-4 p-6 *:last:mt-6",
        legacy: "[&>*]:p-3 [&>*:first-child]:pb-0",
        none: "",
      },
    },
    defaultVariants: {
      variant: "confirmation",
    },
    compoundVariants: [
      {
        spacing: "legacy",
        variant: "modal",
        class: "p-5",
      },
      {
        spacing: "legacy",
        variant: "confirmation",
        class: "px-4 py-2",
      },
    ],
  }
)
